import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { EmptyState, ErrorState, LoadingRows } from "@/components/States";
import { useAuth } from "@/context/AuthContext";
import { fetchLocksmiths, useAsync } from "@/lib/queries";
import { LocksmithDialog } from "./LocksmithDialog";

export default function LocksmithEditPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { profile } = useAuth();
  const requestedReturn = location.state?.returnTo;
  const returnTo = requestedReturn?.startsWith("/manager/locksmiths") ? requestedReturn : "/manager/locksmiths";
  const { data: team, loading, error, reload } = useAsync(fetchLocksmiths, [id]);
  const member = team?.find((person) => person.id === id);
  const companyOwnerId = profile.company?.owner_user_id;
  const isOwner = !companyOwnerId || companyOwnerId === profile.id;
  const canEdit = member && (isOwner || member.role !== "manager" || member.id === profile.id);

  if (member && !canEdit) return <Navigate to={returnTo} replace />;
  if (loading && !team) return <LoadingRows rows={4} />;
  if (error) return <ErrorState message={error} onRetry={reload} />;
  if (!member) return <EmptyState title="Team member not found" description="They may no longer be on this team." testId="team-member-edit-not-found" />;

  const leaveEditor = () => navigate(returnTo);
  return (
    <LocksmithDialog
      open
      pageMode
      locksmith={member}
      onOpenChange={(open) => !open && leaveEditor()}
      onSaved={() => navigate(returnTo, { replace: true })}
    />
  );
}